/*
 * Reliance — Composeur « Choisir sa crème » (sections/rel-diagnostic-cremes.liquid, E.2r1 / E.2r2).
 *  - onglets Sur-mesure / Actives (tabs ARIA : flèches, Début, Fin) ;
 *  - curseur de degré + fragrance : met à jour la fiche, le visuel, le prix et l'article ajoutable ;
 *  - rappel de fragrance visible tant que la fragrance par défaut (« Sans parfum ») est choisie ;
 *  - actives : en-tête de colonne cliquable (met la colonne en avant) ;
 *  - boutons « Explorer cette famille » de la section « Deux tempéraments » (E.2r3) : ouvrent l'onglet.
 * Routine (E.2r2) : « Ajouter à ma routine » ne touche plus au panier. Le bouton coche / décoche la crème dans la
 * sélection du module (une seule crème : sur-mesure OU une active) ; la section « Votre routine »
 * (assets/rel-routine.js) reflète la crème de l'onglet ouvert et c'est sa barre qui remplit le panier.
 * L'état (onglet, degré, fragrance, active, crème choisie) est sauvegardé en sessionStorage par le module.
 * Contrat data-* : en tête de la section.
 */
(function () {
  if (window.relCremesInit) return;
  window.relCremesInit = true;

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function init(root) {
    if (root.relCremes) return;
    var tabs = all(root, '[data-rel-cremes-tab]');
    var panels = all(root, '[data-rel-cremes-panel]');
    var titles = all(root, '[data-rel-cremes-title]');
    var stops = all(root, '[data-rel-cremes-level]');
    var levelPanels = all(root, '[data-rel-cremes-level-panel]');
    var media = all(root, '[data-rel-cremes-media]');
    var scents = all(root, '[data-rel-cremes-scent]');
    var scentNote = root.querySelector('[data-rel-cremes-scent-note]');
    var scentLabel = root.querySelector('[data-rel-cremes-scent-label]');
    var reminder = root.querySelector('[data-rel-cremes-reminder]');
    var picks = all(root, '[data-rel-cremes-active]');
    var cols = all(root, '[data-col]');
    var smItem = root.querySelector('[data-rel-selection-item="surmesure"]');

    var defaults = {
      tab: root.getAttribute('data-default-tab') || 'surmesure',
      level: toInt(root.getAttribute('data-default-level'), 0),
      scent: toInt(root.getAttribute('data-default-scent'), 0),
      active: root.getAttribute('data-default-active') || '',
    };
    var state = { tab: defaults.tab, level: defaults.level, scent: defaults.scent, active: defaults.active };

    function hasTab(tab) {
      return panels.some(function (p) {
        return p.getAttribute('data-rel-cremes-panel') === tab;
      });
    }

    function scentButton(i) {
      return scents.filter(function (b) {
        return toInt(b.getAttribute('data-rel-cremes-scent'), -1) === i;
      })[0];
    }

    function productData() {
      if (!smItem) return null;
      return all(smItem, '[data-rel-cremes-product]').filter(function (el) {
        return (
          toInt(el.getAttribute('data-level'), -1) === state.level &&
          toInt(el.getAttribute('data-scent'), -1) === state.scent
        );
      })[0];
    }

    /* ---------- rendu ---------- */
    function renderTabs() {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-rel-cremes-tab') === state.tab;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-rel-cremes-panel') !== state.tab;
      });
      titles.forEach(function (title) {
        title.hidden = title.getAttribute('data-rel-cremes-title') !== state.tab;
      });
    }

    function renderSurMesure() {
      stops.forEach(function (stop) {
        stop.setAttribute('aria-pressed', toInt(stop.getAttribute('data-rel-cremes-level'), -1) === state.level ? 'true' : 'false');
      });
      levelPanels.forEach(function (panel) {
        panel.hidden = toInt(panel.getAttribute('data-rel-cremes-level-panel'), -1) !== state.level;
      });
      media.forEach(function (el) {
        el.hidden = !(
          toInt(el.getAttribute('data-level'), -1) === state.level &&
          toInt(el.getAttribute('data-scent'), -1) === state.scent
        );
      });
      scents.forEach(function (b) {
        b.setAttribute('aria-pressed', toInt(b.getAttribute('data-rel-cremes-scent'), -1) === state.scent ? 'true' : 'false');
      });
      var current = scentButton(state.scent);
      if (current) {
        if (scentNote) scentNote.textContent = current.getAttribute('data-note') || '';
        if (scentLabel) scentLabel.textContent = current.getAttribute('data-name') || '';
      }
      if (reminder) reminder.hidden = state.scent !== defaults.scent;

      if (!smItem) return;
      var data = productData();
      var available = !!data && data.getAttribute('data-available') === 'true';
      smItem.setAttribute('data-available', available ? 'true' : 'false');
      smItem.setAttribute('data-variant-id', available ? data.getAttribute('data-variant-id') : '');
      smItem.setAttribute('data-price', available ? data.getAttribute('data-price') : '0');
      smItem.setAttribute('data-summary', data ? data.getAttribute('data-summary') || '' : '');
      smItem.setAttribute('data-item-title', data ? data.getAttribute('data-title') || '' : '');
      var price = smItem.querySelector('[data-rel-cremes-price]');
      if (price) {
        price.textContent = available
          ? data.getAttribute('data-price-label') || ''
          : smItem.getAttribute('data-unavailable-label') || '';
      }
    }

    function renderActives() {
      picks.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-rel-cremes-active') === state.active ? 'true' : 'false');
      });
      cols.forEach(function (cell) {
        cell.setAttribute('data-picked', cell.getAttribute('data-col') === state.active ? 'true' : 'false');
      });
    }

    function render() {
      renderTabs();
      renderSurMesure();
      renderActives();
    }

    /* ---------- boutons « Ajouter à ma routine » ---------- */
    function isPicked(key) {
      return !!root.relSelection && root.relSelection.getSelection().some(function (line) {
        return line.key === key;
      });
    }

    function renderButtons() {
      all(root, '[data-rel-selection-item]').forEach(function (item) {
        var button = item.querySelector('[data-rel-cremes-add]');
        if (!button) return;
        var available = item.getAttribute('data-available') === 'true';
        var on = available && isPicked(item.getAttribute('data-rel-selection-item'));
        button.disabled = !available;
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        button.textContent = available
          ? root.getAttribute(on ? 'data-label-added' : 'data-label-add') || ''
          : item.getAttribute('data-unavailable-label') || '';
        var title = item.getAttribute('data-item-title');
        var template = root.getAttribute('data-label-template');
        if (template && title) {
          button.setAttribute('aria-label', template.replace('[action]', button.textContent.replace(/^✓\s*/, '')).replace('[product]', title));
        }
      });
    }

    /* Une seule crème dans la routine : cocher l'une décoche les autres. */
    function pick(key, on) {
      var selection = root.relSelection;
      if (!selection) return;
      if (on) {
        all(root, '[data-rel-selection-item]').forEach(function (el) {
          var other = el.getAttribute('data-rel-selection-item');
          if (other !== key && isPicked(other)) selection.select(other, false);
        });
      }
      selection.select(key, on);
    }

    function toggle(item) {
      if (item.getAttribute('data-available') !== 'true') return;
      var key = item.getAttribute('data-rel-selection-item');
      var on = !isPicked(key);
      if (on && item.hasAttribute('data-active')) setActive(item.getAttribute('data-active'), true);
      pick(key, on);
    }

    /* Crème de l'onglet ouvert, telle que la section « Votre routine » l'affiche. */
    function currentItem() {
      if (state.tab === 'actives') return root.querySelector('[data-rel-selection-item="active-' + state.active + '"]');
      return smItem;
    }

    function getSoin() {
      var item = currentItem();
      if (!item) return null;
      var data = state.tab === 'actives' ? item : productData();
      var key = item.getAttribute('data-rel-selection-item');
      var available = item.getAttribute('data-available') === 'true';
      return {
        tab: state.tab,
        key: key,
        picked: available && isPicked(key),
        available: available,
        variantId: available ? item.getAttribute('data-variant-id') : '',
        price: item.getAttribute('data-price') || '0',
        priceLabel: (data && data.getAttribute('data-price-label')) || '',
        title: item.getAttribute('data-item-title') || '',
        summary: item.getAttribute('data-summary') || '',
        who: (data && data.getAttribute('data-who')) || '',
        image: (data && data.getAttribute('data-image')) || '',
        handle: (data && data.getAttribute('data-handle')) || '',
      };
    }

    function toggleCurrent() {
      var item = currentItem();
      if (item) toggle(item);
    }

    /* Affiche et coche le produit donné (diagnostic, « Voir ma routine ») ; false s'il n'est pas dans le composeur. */
    function chooseProduct(handle) {
      if (!handle) return false;
      var sm = smItem && all(smItem, '[data-rel-cremes-product]').filter(function (el) {
        return el.getAttribute('data-handle') === handle;
      })[0];
      if (sm) {
        state.tab = 'surmesure';
        state.level = toInt(sm.getAttribute('data-level'), state.level);
        state.scent = toInt(sm.getAttribute('data-scent'), state.scent);
        render();
        pick('surmesure', smItem.getAttribute('data-available') === 'true');
        return true;
      }
      var active = all(root, '[data-rel-selection-item][data-active]').filter(function (el) {
        return el.getAttribute('data-handle') === handle;
      })[0];
      if (!active) return false;
      state.tab = 'actives';
      state.active = active.getAttribute('data-active');
      render();
      pick(active.getAttribute('data-rel-selection-item'), active.getAttribute('data-available') === 'true');
      return true;
    }

    /* ---------- état ---------- */
    function getState() {
      return { tab: state.tab, level: state.level, scent: state.scent, active: state.active, soin: getSoin() };
    }

    /* Cartes « Deux tempéraments » (rel-diagnostic-familles, E.2r3) : button[data-rel-cremes-pick="{onglet}"]
       ouvre l'onglet puis fait défiler jusqu'au composeur ; libellés data-label-pick / data-label-picked. */
    var familyButtons = all(document, '[data-rel-cremes-pick]');

    function renderFamilies() {
      familyButtons.forEach(function (button) {
        var tab = button.getAttribute('data-rel-cremes-pick');
        var on = tab === state.tab;
        button.hidden = !hasTab(tab);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        button.textContent = button.getAttribute(on ? 'data-label-picked' : 'data-label-pick') || button.textContent;
        var card = button.closest('[data-rel-cremes-family]');
        if (card) card.setAttribute('data-picked', on ? 'true' : 'false');
      });
    }

    familyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setTab(button.getAttribute('data-rel-cremes-pick'));
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    function emit() {
      renderButtons();
      renderFamilies();
      root.dispatchEvent(new CustomEvent('rel-cremes:change', { bubbles: true, detail: getState() }));
    }

    function changed() {
      render();
      if (root.relSelection) root.relSelection.refresh(); /* émet rel-selection:change → emit() */
      else emit();
    }

    function setTab(tab) {
      if (!hasTab(tab) || tab === state.tab) return;
      state.tab = tab;
      changed();
    }

    function setLevel(i) {
      i = toInt(i, state.level);
      if (i < 0 || i >= stops.length || i === state.level) return;
      state.level = i;
      changed();
    }

    function setScent(i) {
      i = toInt(i, state.scent);
      if (!scentButton(i) || i === state.scent) return;
      state.scent = i;
      changed();
    }

    function setActive(key, silent) {
      if (!key || key === state.active) return;
      if (!picks.some(function (b) { return b.getAttribute('data-rel-cremes-active') === key; })) return;
      var hadPick = isPicked('active-' + state.active);
      state.active = key;
      if (silent) return render();
      /* Comme la maquette : l'active cochée suit la colonne mise en avant. */
      var next = root.querySelector('[data-rel-selection-item="active-' + key + '"]');
      render();
      if (hadPick && next && next.getAttribute('data-available') === 'true') pick('active-' + key, true);
      else if (root.relSelection) root.relSelection.refresh();
      else emit();
    }

    /* ---------- événements ---------- */
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        setTab(tab.getAttribute('data-rel-cremes-tab'));
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = tabs[(index + 1) % tabs.length];
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = tabs[(index - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        setTab(next.getAttribute('data-rel-cremes-tab'));
        next.focus();
      });
    });

    stops.forEach(function (stop) {
      stop.addEventListener('click', function () {
        setLevel(stop.getAttribute('data-rel-cremes-level'));
      });
    });

    scents.forEach(function (b) {
      b.addEventListener('click', function () {
        setScent(b.getAttribute('data-rel-cremes-scent'));
      });
    });

    picks.forEach(function (b) {
      b.addEventListener('click', function () {
        setActive(b.getAttribute('data-rel-cremes-active'));
      });
    });

    all(root, '[data-rel-cremes-add]').forEach(function (button) {
      var item = button.closest('[data-rel-selection-item]');
      if (!item) return;
      button.addEventListener('click', function () {
        toggle(item);
      });
    });

    root.addEventListener('rel-selection:change', function (event) {
      if (event.target === root) emit();
    });

    /* ---------- démarrage ---------- */
    function saveState() {
      return getState();
    }

    function restoreState(saved) {
      if (!saved) return;
      if (hasTab(saved.tab)) state.tab = saved.tab;
      var lvl = toInt(saved.level, -1);
      if (lvl >= 0 && lvl < stops.length) state.level = lvl;
      var sc = toInt(saved.scent, -1);
      if (scentButton(sc)) state.scent = sc;
      if (saved.active && picks.some(function (b) { return b.getAttribute('data-rel-cremes-active') === saved.active; })) {
        state.active = saved.active;
      }
      render();
    }

    render();

    root.relCremes = {
      getState: getState,
      getSoin: getSoin,
      toggleCurrent: toggleCurrent,
      chooseProduct: chooseProduct,
      setTab: setTab,
      setLevel: setLevel,
      setScent: setScent,
      setActive: setActive,
    };

    if (window.RelSelectionCart) {
      window.RelSelectionCart.init(root, { saveState: saveState, restoreState: restoreState });
    }
    emit();
  }

  function boot() {
    document.querySelectorAll('[data-rel-cremes]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
